import { render, staticRenderFns } from "./MemberProfile.vue?vue&type=template&id=6c654756&"
import script from "./MemberProfile.vue?vue&type=script&lang=js&"
export * from "./MemberProfile.vue?vue&type=script&lang=js&"
import style0 from "./MemberProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports